import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { publicAPI } from '../../services/api';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [logoUrl, setLogoUrl] = useState('/logo.png');
  const [headerBg, setHeaderBg] = useState(null);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Cargar datos dinámicos (logo y fondo del header)
    const fetchData = async () => {
      try {
        const logoResponse = await publicAPI.getLogos('header');
        if (logoResponse.data && logoResponse.data.length > 0) {
          setLogoUrl(logoResponse.data[0].file_path);
        }

        const imagesResponse = await publicAPI.getHeaderImages();
        if (imagesResponse.data && imagesResponse.data.length > 0) {
          setHeaderBg(imagesResponse.data[0].file_path);
        }
      } catch (error) {
        console.error('Error cargando datos:', error);
      }
    };
    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(username, password);

    if (result.success) {
      navigate('/backoffice');
    } else {
      setError(result.message);
    }

    setLoading(false);
  };

  return (
    <div className="login-page" style={{ backgroundImage: headerBg ? `url(${headerBg})` : 'none', color: 'rgb(116, 70, 49)' }}>
      <div className="login-container">
        <div className="login-box">
          <img src={logoUrl} alt="Logo IMDI" className="login-logo" />
          <h1>Iniciar Sesión</h1>
          <p className="login-subtitle">Accede al panel de administración</p>

          {error && <div className="error-message">{error}</div>}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="username">Usuario</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoFocus
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Contraseña</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="login-button" disabled={loading}>
              {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
